import { useEffect } from 'react';

import { useSelectedAccount } from '@/lib/accounts/context';

import { useConversationQuery } from '@/graphql';

import { useConversationRepositoryContext } from '@/explore/conversation/conversation-repository-context';
import { convertConversationType } from '@/explore/input';

import { useAsyncCallback } from '@/lib/hooks/use-async-callback';
import { useDocumentVisibility } from '@/lib/hooks';
import { hasRunningJobs } from '@/core/conversation';

export const useConversation = (conversationId: string) => {
  const { accountId } = useSelectedAccount();
  const { setConversation, getConversation } = useConversationRepositoryContext();
  const isDocumentVisible = useDocumentVisibility();

  const conversation = getConversation(conversationId);

  const { data, error, refetch, loading } = useConversationQuery({
    variables: { accountId, conversationId },
    pollInterval: isDocumentVisible && hasRunningJobs(conversation) ? 1000 : 0,
    fetchPolicy: 'cache-first',
    returnPartialData: true,
    skipPollAttempt: () => hasErrored() ?? false,
  });

  const hasErrored = useAsyncCallback(() => {
    return error !== undefined;
  });

  useEffect(() => {
    const conversation = convertConversationType(data?.account?.conversation);
    if (conversation !== null) {
      setConversation(conversation);
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.account?.conversation]);

  return {
    error,
    refetch,
    loading,
  };
};
